export default __webpack_public_path__ + "static/media/img4.8ea149b4.png";